module.exports = __webpack_public_path__ + "img/menu_profile.f92acc60.svg";